<div class="review">
  <div class="user-box">
    <img class="user-pic" [src]="getReviewPic()">
  </div>
  <div class="review-info">
    <div class="review-title">
      <div class="user-name">{{review.username}}</div>
      <span class="r-title">{{review.title}}</span>
      <div *ngIf="review.rating > 0" class="review-rating">
        <img src="./assets/images/gold_star.png">
        <span class="review-note">{{review.rating}}</span>/10
      </div>
    </div>
    <div #reviewText class="review-text">
      <span #text>{{review.text}}</span>
      <div [class.hidden]="!textIsLong() || showMore" class="more" (click)="showMore = true;scale()">{{getString('more')}}</div>
      <div [class.hidden]="!textIsLong() || !showMore" class="less" (click)="showMore = false;scale()">{{getString('less')}}</div>
    </div>
    <div class="bottom-container">
      <div class="review-date">{{formatDate(review.dateCreated.value)}}</div>
      <div class="review-votes">{{getVotesText()}}
        <button type="button" class="green-btn" (click)="upvote()">{{getString('yes')}}</button>
        <button type="button" class="red-btn" (click)="downvote()">{{getString('no')}}</button>
        <span *ngIf="showEdit()" (click)="edit()" class="edit-btn blue-text">{{getString('edit')}}</span>
      </div>
    </div>
  </div>
</div>

<div class="mobile-review">
  <div class="user-box">
    <img class="user-pic" [src]="getReviewPic()">
  </div>
  <div class="review-info">
    <div *ngIf="review.rating > 0" class="review-rating">
      <img src="./assets/images/gold_star.png">
      <span class="review-note">{{review.rating}}</span>/10
    </div>
  </div>

  <div class="review-title">
    <div class="user-name">{{review.username}}</div>
    <span class="r-title">{{review.title}}</span>
  </div>

  <div #reviewTextMobile class="review-text">
    <span #textMobile>{{review.text}}</span>
    <div [class.hidden]="!textMobileIsLong() || showMore" class="more" (click)="showMore = true;scale()">{{getString('more')}}</div>
    <div [class.hidden]="!textMobileIsLong() || !showMore" class="less" (click)="showMore = false;scale()">{{getString('less')}}</div>
  </div>

  <div class="bottom-container">
    <div class="review-date">{{formatDate(review.dateCreated.value)}}</div>
    <div class="review-votes">{{getVotesText()}}
    <div class="yes-no-btn-container">
      <button type="button" class="green-btn" (click)="upvote()">{{getString('yes')}}</button>
      <button type="button" class="red-btn" (click)="downvote()">{{getString('no')}}</button>
    </div>
      <span *ngIf="showEdit()" (click)="edit()" class="edit-btn blue-text">{{getString('edit')}}</span>
    </div>
  </div>

</div>